import AcfHelper from "../../_acf";
import Slider from "../../utils/_slider";

const blockClass = 'quotations-block';
const slidersClass = `quotations-slider`;

const Quotations = {};

Quotations.blockName = 'quotations';

Quotations.init = () => {
    AcfHelper.handleInit(Quotations.blockName, () => {
        Slider.init({
            slider: slidersClass,
            container: blockClass,
        }, {
            loop: false,
        });
    });
};

Quotations.init();

export default Quotations;
